// Design tokens shared by the course-hub session list pieces (matches the design prototype).
const DS = {
  primary50:  "color-mix(in srgb, var(--color-primary) 8%, transparent)",

  ink:  "var(--color-ink)",
  ink2: "rgba(31,22,51,0.75)",
  ink3: "rgba(31,22,51,0.6)",
  ink4: "rgba(31,22,51,0.5)",

  line:  "var(--color-hairline-cloud)",
  line2: "var(--color-hairline-cloud)",
  line3: "var(--color-hairline-cloud)",

  surface:  "var(--color-surface-canvas-light)",
  surface2: "var(--color-surface-press-light)",
  surface3: "var(--color-surface-press-stronger)",
  pageBg:   "var(--color-surface-2)",

  live:    "#c23d68",
  live50:  "color-mix(in srgb, var(--color-accent-pink) 10%, transparent)",
  liveBg:  "color-mix(in srgb, var(--color-accent-pink) 15%, transparent)",
  liveBr:  "color-mix(in srgb, var(--color-accent-pink) 22%, transparent)",

  blue:     "var(--color-primary)",
  blue50:   "rgba(37,99,235,.10)",
  purple:   "var(--color-status-neutral)",
  purple50: "rgba(121,98,140,.14)",

  danger:   "var(--color-danger)",
  danger50: "var(--color-danger-bg)",

  grey:    "var(--color-ink-3)",
  greyBg:  "rgba(107,114,128,.10)",

  shadowSm: "var(--shadow-card-sm)",
  shadowMd: "var(--shadow-card-md)",
};

export default DS;
